<template>
  <div class="tel">
    <button @click="signIn">Twitterでログイン</button>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'Signin',
  data: function () {
    return {}
  },
  methods: {
    signIn: function () {
      let provider = new firebase.auth.TwitterAuthProvider()
      firebase.auth().signInWithPopup(provider).then(result => {
        this.$emit('finishAuth')
      }).catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
p.errorMessage{
  color: #f00;
}
input.error {
  border-color: #f00;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/twitter.vue